import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    name: 'IndexPage',
    path: '/index',
    component: () => import('@/view/index/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/view/login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    name: 'SimulationExam',
    path: '/simulationExam',
    component: () => import('@/view/simulationExam/index.vue'),
    meta: {
      title: '模拟考试'
    }
  },
  {
    name: 'ExamQuestionBank',
    path: '/examQuestionBank',
    component: () => import('@/view/examQuestionBank/index.vue'),
    meta: {
      title: '试题库'
    }
  },
  {
    name: 'MistakeNotebook',
    path: '/mistakeNotebook',
    component: () => import('@/view/mistakeNotebook/index.vue'),
    meta: {
      title: '错题本'
    }
  },
  {
    name: 'QuestionDetails',
    path: '/questionDetails',
    component: () => import('@/view/examQuestionBank/questionDetails.vue'),
    meta: {
      title: '试题详情'
    }
  },
  {
    name: 'DoPracticeQuestions',
    path: '/doPracticeQuestions',
    component: () => import('@/view/doPracticeQuestions/index.vue'),
    meta: {
      title: '抽题练习'
    }
  },
  {
    name: 'DoPracticeMistakesQuestions',
    path: '/doPracticeMistakesQuestions',
    component: () => import('@/view/doPracticeQuestions/index.vue'),
    meta: {
      title: '错题练习'
    }
  },
  {
    name: 'WaitExam',
    path: '/waitExam',
    component: () => import('@/view/waitExam/index.vue'),
    meta: {
      title: '待参加考试'
    }
  },
  {
    name: 'AlreadyExam',
    path: '/alreadyExam',
    component: () => import('@/view/alreadyExam/index.vue'),
    meta: {
      title: '已参加考试'
    }
  },
  {
    name: 'DoExam',
    path: '/doExam',
    component: () => import('@/view/doExam/index.vue'),
    meta: {
      title: '开始考试'
    }
  },
  {
    name: 'ViewExam',
    path: '/viewExam',
    component: () => import('@/view/viewExam/index.vue'),
    meta: {
      title: '查看考试'
    }
  },
  {
    name: 'survey',
    path: '/survey',
    component: () => import('@/view/survey/index.vue'),
    meta: {
      title: '问卷调查'
    }
  },
  {
    name: 'surveyList',
    path: '/surveyList',
    component: () => import('@/view/survey/surveyList.vue'),
    meta: {
      title: '问卷列表'
    }
  },
  {
    name: 'Example',
    path: '/example',
    component: () => import('@/view/example/index.vue'),
    meta: {
      title: '例子页面'
    }
  },
  {
    path: '*',
    component: () => import('@/view/page404/index.vue'),
    meta: {
      title: '404'
    }
  }
];


const router = new Router({ routes });

export {
  router
};
